module.exports = __webpack_public_path__ + "static/iso_1.c98422fb.jpg";